import React, { useState } from "react";
import { Input, Tag } from "antd";
import styles from "../styles/BusinessInfo.module.css";

export default function BusinessAudience({ answers, onAnswerChange }) {
    // State for audience input
    const [audienceInput, setAudienceInput] = useState(
        Array.isArray(answers.targetAgeGroups)
            ? answers.targetAgeGroups.join(", ")
            : answers.targetAudience || ""
    );

    // NEW: State for tone input
    const [toneInput, setToneInput] = useState(
        Array.isArray(answers.targetInterests)
            ? answers.targetInterests.join(", ")
            : answers.targetInterests || ""
    );

    // Handle audience input change
    const handleAudienceInputChange = (e) => {
        const value = e.target.value;
        setAudienceInput(value);

        // Parse comma-separated values into array
        const audiences = value
            .split(",")
            .map((item) => item.trim())
            .filter((item) => item !== "");

        onAnswerChange("targetAgeGroups", audiences);
    };

    // NEW: Handle tone input change
    const handleToneInputChange = (e) => {
        const value = e.target.value;
        setToneInput(value);

        // Parse comma-separated values into array
        const tones = value
            .split(",")
            .map((item) => item.trim())
            .filter((item) => item !== "");

        onAnswerChange("targetInterests", tones);
    };

    // Handle adding an audience suggestion to the input
    const addSuggestion = (suggestion) => {
        // Get current value as array
        const currentValues = audienceInput
            ? audienceInput.split(",").map((item) => item.trim())
            : [];

        // Check if suggestion already exists
        if (!currentValues.includes(suggestion)) {
            // Add the new suggestion
            const newValue =
                currentValues.length > 0 && currentValues[0] !== ""
                    ? `${audienceInput}, ${suggestion}`
                    : suggestion;

            setAudienceInput(newValue);

            // Update answer state
            const audiences = newValue
                .split(",")
                .map((item) => item.trim())
                .filter((item) => item !== "");

            onAnswerChange("targetAgeGroups", audiences);
        }
    };

    // NEW: Handle adding a tone suggestion to the input
    const addToneSuggestion = (suggestion) => {
        // Get current value as array
        const currentValues = toneInput
            ? toneInput.split(",").map((item) => item.trim())
            : [];

        // Check if suggestion already exists
        if (!currentValues.includes(suggestion)) {
            // Add the new suggestion
            const newValue =
                currentValues.length > 0 && currentValues[0] !== ""
                    ? `${toneInput}, ${suggestion}`
                    : suggestion;

            setToneInput(newValue);

            // Update answer state
            const tones = newValue
                .split(",")
                .map((item) => item.trim())
                .filter((item) => item !== "");

            onAnswerChange("targetInterests", tones);
        }
    };

    const ageGroupOptions = [
        { value: "Students", label: "Students" },
        { value: "Working Professionals", label: "Working Professionals" },
        { value: "Business Owners", label: "Business Owners" },
        { value: "Homemakers", label: "Homemakers" },
    ];

    // Tone options as suggestions
    const toneOptions = [
        { value: "Formal", label: "Formal" },
        { value: "Friendly", label: "Friendly" },
        { value: "Inspirational", label: "Inspirational" },
        { value: "Bold", label: "Bold" },
        { value: "Informative", label: "Informative" },
        { value: "Fun", label: "Fun" },
        { value: "Educational", label: "Educational" },
        { value: "Professional", label: "Professional" },
        { value: "Casual", label: "Casual" },
        { value: "Humorous", label: "Humorous" },
    ];

    return (
        <div className={styles.slideContent}>
            <div
                className={styles.questionsContainer}
                style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "40px",
                }}
            >
                {/* First question - Age Groups with Tags */}
                <div className={styles.questionGroup}>
                    <label className={styles.slideTitle}>
                        Who is your product/service primarily for?
                    </label>
                    <div style={{ marginTop: "15px" }}>
                        <Input.TextArea
                            // style={{ width: "500px" }}
                            placeholder="Enter your target audience, e.g., working moms or tech startups"
                            value={audienceInput}
                            onChange={handleAudienceInputChange}
                            size="large"
                            rows={3}
                        />
                    </div>
                    <div
                        style={{
                            padding: "10px 0",
                            borderRadius: "10px",
                            // maxWidth: "600px", 
                            // margin: "0 auto",
                        }}
                    >
                        {/* <span style={{ marginRight: "10px", color: "#666" }}>
                            Suggestions:
                        </span> */}
                        {ageGroupOptions.map((suggestion) => (
                            <Tag
                                key={suggestion.value}
                                style={{
                                    cursor: "pointer",
                                    margin: "4px",
                                    fontSize: "14px",
                                    padding: "4px 10px",
                                    // border: "1px solid #1ba698",
                                    border: "1px dashed #aaa",
                                    color: "gray",
                                    backgroundColor:
                                        "rgba(252, 255, 255, 0.73)",
                                }}
                                onClick={() => addSuggestion(suggestion.value)}
                            >
                                {suggestion.label}
                            </Tag>
                        ))}
                    </div>
                </div>

                {/* Second question - Tone with input and suggestions */}
                <div className={styles.questionGroup}>
                    <label className={styles.slideTitle}>
                        How should your content feel to the reader?
                    </label>
                    <div style={{ marginTop: "15px" }}>
                        <Input.TextArea
                            // style={{ width: "500px" }}
                            placeholder="Describe your vibe: fun, serious, sarcastic?"
                            value={toneInput}
                            onChange={handleToneInputChange}
                            size="large"
                            rows={3}
                        />
                    </div>
                    <div
                        style={{
                            padding: "10px 0",
                            borderRadius: "10px",
                            // maxWidth: "600px",
                            margin: "0 auto",
                        }}
                    >
                        {/* <span style={{ marginRight: "10px", color: "#666" }}>
                            Suggestions:
                        </span> */}
                        {toneOptions.map((suggestion) => (
                            <Tag
                                key={suggestion.value}
                                style={{
                                    cursor: "pointer",
                                    margin: "4px",
                                    fontSize: "14px",
                                    padding: "4px 10px",
                                    // border: "1px solid #1ba698",
                                    border: "1px dashed #aaa",
                                    color: "gray",
                                    backgroundColor:
                                        "rgba(252, 255, 255, 0.73)",
                                }}
                                onClick={() =>
                                    addToneSuggestion(suggestion.value)
                                }
                            >
                                {suggestion.label}
                            </Tag>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}
